import img from "../../../assets/Picture1.png";
import logo from "../../../assets/logo.png";
import {
    Document,
    Page,
    StyleSheet,
    Image,
    Text,
    View,
    pdf,
} from "@react-pdf/renderer";

const PDFDocument = ({ data }) => (
    <Document>
        <Page size='A4' style={styles.page}>
            {data && (
                <>
                    {/* Fixed Header */}
                    <View fixed style={styles.rightImage}>
                        <Image src={img} style={styles.logo1} />
                    </View>
                    <Image fixed src={logo} style={styles.logo} />
                    <View style={styles.companyDetails}>
                        <Text style={styles.companyName}>One Union Solutions B.V.</Text>
                        <Text style={styles.companyText}>Legmeerdijk 169C</Text>
                        <Text style={styles.companyText}>1432 KA Aalsmeer</Text>
                        <Text style={styles.companyText}>Netherlands</Text>
                        <Text style={styles.companyText}>P: +31 850607353</Text>
                        <Text style={styles.companyText}>E: info@oneunionsolutions.com</Text>
                    </View>

                    {/* Title Section */}
                    <View style={styles.titleSection}>
                        <Text style={styles.mainTitle}>HS Code Classification Report</Text>
                    </View>

                    {/* Top Code Section */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Recommended HS Code</Text>
                        <View style={styles.codeBox}>
                            <View style={styles.codeHeader}>
                                <Text style={styles.codeNumber}>{data.topCode.code}</Text>
                                <View style={styles.confidenceBadge}>
                                    <Text style={styles.confidenceText}>
                                        {data.topCode.confidence}% Confidence
                                    </Text>
                                </View>
                            </View>
                            <Text style={styles.codeDescription}>
                                {data.topCode.description}
                            </Text>
                        </View>
                    </View>

                    {/* Alternative Codes Section */}
                    {data.alternativeCodes.length > 0 && (
                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>Alternative Codes</Text>
                            {data.alternativeCodes.map((alt, idx) => (
                                <View key={idx} style={styles.alternativeBox}>
                                    <View style={styles.altHeader}>
                                        <Text style={styles.altCode}>{alt.code}</Text>
                                        <Text style={styles.altConfidence}>
                                            {alt.confidence}% Confidence
                                        </Text>
                                    </View>
                                    <Text style={styles.altDescription}>{alt.description}</Text>
                                </View>
                            ))}
                        </View>
                    )}

                    {/* Why This Code Section */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Classification Rationale</Text>
                        <Text style={styles.bodyText}>
                            {data.whyThisCode.exactCodeDescription}
                        </Text>

                        <Text style={styles.subTitle}>Key Identifying Features:</Text>
                        <View style={styles.pillsContainer}>
                            {data.whyThisCode.keywords.map((keyword, idx) => (
                                <View key={idx} style={styles.pill}>
                                    <Text style={styles.pillText}>{keyword}</Text>
                                </View>
                            ))}
                        </View>
                    </View>

                    {/* Feature Extraction Section - PAGE 2 */}
                    <View style={styles.section} break>
                        <Text style={styles.sectionTitle}>Technical Features</Text>
                        {data.featureExtraction.map((feature, idx) => (
                            <View key={idx} style={styles.featureBox}>
                                <Text style={styles.featureLabel}>{feature.label}</Text>
                                <Text style={styles.featureDescription}>{feature.description}</Text>
                            </View>
                        ))}
                    </View>

                    {/* Decision Logic Section - PAGE 3 */}
                    <View style={styles.section} break>
                        <Text style={styles.sectionTitle}>Decision Analysis</Text>
                        <View style={styles.confidenceBox}>
                            <Text style={styles.overallConfidence}>
                                Overall Confidence Score: {data.decisionLogic.confidenceScore}%
                            </Text>
                        </View>

                        <Text style={styles.subTitle}>Contributing Factors:</Text>
                        {data.decisionLogic.factors.map((factor, idx) => (
                            <View key={idx} style={styles.factorBox}>
                                <View style={styles.factorHeader}>
                                    <Text style={styles.factorWeight}>{factor.weight}%</Text>
                                    <Text style={styles.factorText}>{factor.factor}</Text>
                                </View>
                            </View>
                        ))}
                    </View>

                    {/* Exclusions Section */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Excluded Codes</Text>
                        <Text style={styles.bodyText}>
                            The following codes were considered but excluded:
                        </Text>
                        {data.exclusions.map((exclusion, idx) => (
                            <View key={idx} style={styles.exclusionBox}>
                                <Text style={styles.exclusionCode}>{exclusion.code}</Text>
                                <Text style={styles.exclusionDesc}>{exclusion.description}</Text>
                            </View>
                        ))}
                    </View>

                    {/* Page Numbers */}
                    <Text
                        style={styles.pageNumber}
                        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                        fixed
                    />
                </>
            )}
        </Page>
    </Document>
);

export const downloadHsCompassResult = async (data) => {
    try {
        console.log('data from downloadHSCompass', data);
        const blob = await pdf(<PDFDocument data={data} />).toBlob();
        return blob;
    } catch (error) {
        console.error('PDF generation failed:', error);
        throw error;
    }
};

const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        paddingBottom: 60,
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 20,
        position: "relative",
        fontFamily: "Helvetica",
    },
    rightImage: {
        position: "absolute",
        right: 0,
        top: 0,
    },
    logo: {
        width: 100,
        marginBottom: 10,
    },
    logo1: {
        width: "150px",
        marginBottom: 10,
    },
    companyDetails: {
        marginBottom: 22,
    },
    companyName: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#1f3b65",
        marginBottom: 3,
    },
    companyText: {
        fontSize: 9,
        fontWeight: "normal",
        color: "#1f2937",
        lineHeight: 1.4,
    },
    headerImg: {
        width: 150,
    },
    footerImg: {
        width: 150,
        marginTop: 30,
        alignSelf: "center",
    },
    titleSection: {
        marginTop: 10,
        marginBottom: 20,
        borderBottom: 2,
        borderBottomColor: "#2563eb",
        paddingBottom: 10,
    },
    mainTitle: {
        fontSize: 24,
        fontWeight: "bold",
        color: "#1e40af",
    },
    section: {
        marginBottom: 20,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#1e40af",
        marginBottom: 10,
        borderBottom: 1,
        borderBottomColor: "#e5e7eb",
        paddingBottom: 5,
    },
    subTitle: {
        fontSize: 12,
        fontWeight: "bold",
        color: "#374151",
        marginTop: 10,
        marginBottom: 8,
    },
    codeBox: {
        backgroundColor: "#eff6ff",
        padding: 15,
        borderRadius: 4,
        borderLeft: 4,
        borderLeftColor: "#2563eb",
    },
    codeHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 8,
    },
    codeNumber: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#1e40af",
    },
    confidenceBadge: {
        backgroundColor: "#22c55e",
        padding: 5,
        borderRadius: 3,
    },
    confidenceText: {
        fontSize: 10,
        color: "#ffffff",
        fontWeight: "bold",
    },
    codeDescription: {
        fontSize: 11,
        color: "#374151",
        lineHeight: 1.5,
    },
    bodyText: {
        fontSize: 11,
        color: "#374151",
        lineHeight: 1.6,
        textAlign: "justify",
    },
    pillsContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 6,
        marginTop: 5,
    },
    pill: {
        backgroundColor: "#e5e7eb",
        borderRadius: 12,
        paddingVertical: 5,
        paddingHorizontal: 10,
    },
    pillText: {
        fontSize: 9,
        fontWeight: "bold",
    },
    featureBox: {
        marginBottom: 12,
        paddingLeft: 10,
        borderLeft: 2,
        borderLeftColor: "#93c5fd",
    },
    featureLabel: {
        fontSize: 11,
        fontWeight: "bold",
        color: "#1e40af",
        marginBottom: 3,
    },
    featureDescription: {
        fontSize: 10,
        color: "#4b5563",
        lineHeight: 1.4,
    },
    alternativeBox: {
        backgroundColor: "#fef3c7",
        padding: 12,
        marginBottom: 10,
        borderRadius: 4,
        borderLeft: 3,
        borderLeftColor: "#f59e0b",
    },
    altHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 5,
    },
    altCode: {
        fontSize: 13,
        fontWeight: "bold",
        color: "#92400e",
    },
    altConfidence: {
        fontSize: 10,
        color: "#92400e",
    },
    altDescription: {
        fontSize: 10,
        color: "#78350f",
        lineHeight: 1.4,
    },
    exclusionBox: {
        marginBottom: 8,
        paddingLeft: 10,
        borderLeft: 2,
        borderLeftColor: "#fca5a5",
    },
    exclusionCode: {
        fontSize: 11,
        fontWeight: "bold",
        color: "#dc2626",
        marginBottom: 3,
    },
    exclusionDesc: {
        fontSize: 10,
        color: "#4b5563",
        lineHeight: 1.4,
    },
    confidenceBox: {
        backgroundColor: "#dcfce7",
        padding: 10,
        borderRadius: 4,
        marginBottom: 10,
        textAlign: "center",
    },
    overallConfidence: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#166534",
    },
    factorBox: {
        marginBottom: 8,
        backgroundColor: "#f9fafb",
        padding: 10,
        borderRadius: 3,
    },
    factorHeader: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    factorWeight: {
        fontSize: 12,
        fontWeight: "bold",
        color: "#2563eb",
        minWidth: 35,
    },
    factorText: {
        fontSize: 10,
        color: "#374151",
        flex: 1,
        lineHeight: 1.4,
    },
    pageNumber: {
        position: "absolute",
        fontSize: 10,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
        color: "#6b7280",
    },
});
